import React from 'react';
import DomainUtils from '../utils/domainUtils';
import logger from '../utils/logger';

const UnauthenticatedRoutes = ({ setIsLoggedIn, setCurrentAccount, setUserDetails, onLoginSuccess }) => {
  // For admin app, redirect unauthenticated users to accounts app for login
  React.useEffect(() => {
    // CRITICAL FIX: Prevent redirect loops
    const redirectCount = parseInt(sessionStorage.getItem('redirectCount') || '0');
    const lastRedirectTime = parseInt(sessionStorage.getItem('lastRedirectTime') || '0');
    const now = Date.now();

    // If we've redirected 3+ times in the last 30 seconds, stop redirecting
    if (redirectCount >= 3 && (now - lastRedirectTime) < 30000) {
      logger.error('REDIRECT LOOP DETECTED - Stopping automatic redirects');
      return;
    }

    // Track this redirect
    if (now - lastRedirectTime < 30000) {
      sessionStorage.setItem('redirectCount', (redirectCount + 1).toString());
    } else {
      // Reset counter if more than 30 seconds have passed
      sessionStorage.setItem('redirectCount', '1');
    }
    sessionStorage.setItem('lastRedirectTime', now.toString());

    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;

    // Build redirect URL to return to admin app after login
    const adminReturnUrl = DomainUtils.buildUrl('admin', currentPath + currentSearch);
    const accountsLoginUrl = DomainUtils.buildUrl('accounts', `/login?redirect=${encodeURIComponent(adminReturnUrl)}`);

    // Add a small delay to ensure any pending auth sync completes
    const timeoutId = setTimeout(() => {
      window.location.href = accountsLoginUrl;
    }, 500);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to login...</p>
        <p className="text-xs text-gray-400 mt-2">If you are not redirected, <a href={DomainUtils.buildUrl('accounts', '/login')} className="text-orange-500 underline">click here</a>.</p>
      </div>
    </div>
  );
};

export default UnauthenticatedRoutes;